import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Notifications from 'react-notification-system-redux'
import './GlobalNotifications.css'

export const GlobalNotifications = props => (
  <Notifications
    notifications={props.notifications}
    noAnimation
    style={false} // eslint-disable-line
  />
)

GlobalNotifications.contextTypes = {
  store: PropTypes.object,
}

GlobalNotifications.propTypes = {
  notifications: PropTypes.array,
}

const mapStateToProps = state => ({
  notifications: state.notifications,
})

export default connect(mapStateToProps)(GlobalNotifications)



// WEBPACK FOOTER //
// ./src/components/ui/notifications/GlobalNotifications.js